var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-panel"},[(_vm.title)?_c('p',{staticClass:"info-panel-header"},[_c('fa',{attrs:{"icon":"info-circle","fixed-width":""}}),_vm._v(" "+_vm._s(_vm.title)+" ")],1):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }